import React, { useContext, useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import AppContext from "../../context/AppContext";
import translations from "../../components/common/Translations";
import { RiDeleteBin5Line } from "react-icons/ri";
import { toast } from "react-toastify";

const translation = {
    en: {
        validations: "Validations",
        code: "Validation Code",
        msg: "Error Message",
        update: "Update",
        cancel: "Close",
    },
    ar: {
        validations: "التحققات",
        code: "رمز التحقق",
        msg: "رسالة خطأ",
        update: "تحديث",
        cancel: "إغلاق",
    },
};

const ViewValidationModal = ({
    previewKey,
    preview,
    setViewValidationModal,
    viewValidationModal,
    currentValidation,
    setCurrentValidation,
    validationId,
    setValidationFormValues,
    validationFormValues,
    updateValidationField, // Pass the function from parent
    handleValidationDelete
}) => {
    const { theme, langMode } = useContext(AppContext);
    const [validations, setValidations] = useState([]);
    console.log(validationId)
    // Initialize validations from preview
    useEffect(() => {
        if (preview?.validationValues) {
            setValidations(preview.validationValues);
        }
    }, [preview]);

    // Close Modal
    const onCloseValidation = () => {
        setViewValidationModal(false);
    };

    const handleValidationUpdate = (id, field, value) => {
        const updatedValidations = validations.map((validation) =>
          validation.id === id ? { ...validation, [field]: value } : validation
        );
        setValidations(updatedValidations);
      
        setCurrentValidation({
          ...currentValidation,
          [field]: value,
          validationId: id,
          uniqueKey: previewKey,
        });
      };
      

    // Save Changes and Inform Parent
    const handleSaveChanges = () => {
        console.log("Validations before saving:", validations); // Log the full validations array
        updateValidationField(validations, previewKey); // Call the parent's update function
        setViewValidationModal(false);
    };


    const handleDelete = (id) => {
        // Call the delete function passed from the parent
        handleValidationDelete(id, previewKey ,id);

        // Update the local validations state
        const updatedValidations = validations.filter((validation) => validation.id !== id);
        setValidations(updatedValidations);
        toast.success("Validation removed, Update the workflow for Deletion ")
    };


    return (
        viewValidationModal && (
            <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
                <div
                    className={`bg-white rounded-lg p-6 relative max-w-lg w-full overflow-y-auto shadow-md ${theme === "dark"
                        ? "dark-mode border"
                        : theme === "high-contrast"
                            ? "high-contrast"
                            : ""
                        }`}
                >
                    {/* Close Button */}
                    <button
                        className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                        onClick={onCloseValidation}
                    >
                        <RxCross2 />
                    </button>

                    {/* Header */}
                    <h3 className="text-lg font-bold mb-4">
                        {translation[langMode]?.validations}
                    </h3>

                    {/* Validation List */}
                    {validations.length > 0 ? (
                        <div className="space-y-3  h-[200px] overflow-y-auto">
                            {validations.map((validation) => (
                                <div
                                    key={validation.id}
                                    className="p-4 border rounded-lg bg-gray-50"
                                >
                                    {/* Validation Code */}
                                    <div className="mb-4">
                                        <div className="flex justify-end relative group mb-4">
                                            <RiDeleteBin5Line
                                                size={20}
                                                color="red"
                                                onClick={() => handleDelete(validation.id)} // Pass the specific validation id
                                                className="cursor-pointer"
                                            />


                                            <span className="absolute top-full mb-2 right-0 transform -translate-x-1/2 whitespace-nowrap bg-gray-700 text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                                Delete Validation
                                            </span>
                                        </div>

                                        <label
                                            htmlFor={`validationCode-${validation.id}`}
                                            className="block text-sm font-medium text-gray-700"
                                        >
                                            {translation[langMode]?.code}
                                        </label>
                                        <input
                                            id={`validationCode-${validation.id}`}
                                            type="text"
                                            value={validation.validationCode}
                                            onChange={(e) =>
                                                handleValidationUpdate(
                                                    validation.id,
                                                    "validationCode",
                                                    e.target.value
                                                )
                                            }
                                            className="mt-1 w-full text-xs border border-gray-300 rounded-md p-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>

                                    {/* Error Message */}
                                    <div>
                                        <label
                                            htmlFor={`errorMessage-${validation.id}`}
                                            className="block text-sm font-medium text-gray-700"
                                        >
                                            {translation[langMode]?.msg}
                                        </label>
                                        <input
                                            id={`errorMessage-${validation.id}`}
                                            type="text"
                                            value={validation.errorMessage}
                                            onChange={(e) =>
                                                handleValidationUpdate(
                                                    validation.id,
                                                    "errorMessage",
                                                    e.target.value
                                                )
                                            }
                                            className="mt-1 w-full text-xs border border-gray-300 rounded-md p-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className="text-sm text-gray-500">No validations available.</p>
                    )}

                    {/* Footer Buttons */}
                    <div className="mt-6 flex justify-end space-x-4">
                        <button
                            type="button"
                            onClick={handleSaveChanges}
                            className="px-4 py-2 bg-blue-700 text-white text-xs font-semibold rounded-md hover:bg-blue-600"
                        >
                            {translation[langMode]?.update}
                        </button>
                        <button
                            type="button"
                            onClick={onCloseValidation}
                            className="px-4 py-2 bg-gray-200 text-xs text-gray-800 font-semibold rounded-md hover:bg-gray-300"
                        >
                            {translation[langMode]?.cancel}
                        </button>
                    </div>
                </div>
            </div>
        )
    );
};

export default ViewValidationModal;
